export default {
  data() {
    return {
    };
  },
  props: ['title', 'client'],
  template: '<div class="task shadow clickable">' +
    '<span class="icon"><i class="fal fa-tasks"></i></span>' +
    '<span class="title">{{title | truncate(50) }}</span>' +
    '<span class="client">{{client.name | truncate(50) }}</span>' +
    '</div>',
};



// WEBPACK FOOTER //
// ./src/components/Task.js